<template>
  <div class="home">
    <header-home />
    <a-carousel
      class="carousel"
      autoplay
    >
      <img
        v-for="(item, i) in data.carousel"
        :key="i"
        class="carousel-item"
        :src="item.imgUrl"
      />
    </a-carousel>
    <div class="container">
      <a-tabs
        v-model="tabs1"
        @change="e => handleTabs1Change(e)"
      >
        <a-tab-pane
          :key="1"
          tab="新闻资讯"
        >
          <div
            class="flex"
            v-if="data.notice.length"
          >
            <news-item
              v-for="(item, i) in data.notice"
              :key="i"
              :data="item"
              @click="() => handleMenuClick(item)"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane
          :key="2"
          tab="培训通知"
        >
          <div
            class="flex"
            v-if="data.notice.length"
          >
            <news-item
              v-for="(item, i) in data.notice"
              :key="i"
              :data="item"
              @click="() => handleMenuClick(item)"
            />
          </div>
        </a-tab-pane>
        <template #tabBarExtraContent>
          <a-button
            type="link"
            @click="() => handleMenuClick(more)"
          >
            + 查看更多
          </a-button>
        </template>
      </a-tabs>
    </div>
    <div class="container flex gap">
      <forum-item
        v-for="(item, i) in data.shortcut"
        :key="i"
        :data="item"
      />
    </div>
    <div class="container">
      <a-tabs
        v-model="tabs2"
        @change="e => handleTabs2Change(e)"
      >
        <a-tab-pane
          :key="0"
          tab="区域查询"
          class="area-region"
        >
          <div class="headline">
            <div class="left">
              培训机构: <span>{{data.address.traincount}}</span>家
            </div>
            <div class="right">
              服务机构: <span>{{data.address.servecount}}</span>家
            </div>
          </div>
          <china-map
            :data="data.address.list"
          />
        </a-tab-pane>
        <a-tab-pane
          :key="1"
          tab="服务机构"
        >
          <div class="flex flex-vertical">
            <a
              class="flex-item"
              v-for="(item, i) in data.agency"
              :key="i"
              @click="() => handleMenuClick(item)"
            >
              <img :src="item.file_path" />
              <div class="description-box">
                <div class="label">
                  {{item.name}}
                </div>
                <div class="value">
                  {{item.release_time}}
                </div>
              </div>
            </a>
          </div>
        </a-tab-pane>
        <a-tab-pane
          :key="2"
          tab="人员能力"
        >
          <div class="flex flex-horizontal">
            <a
              class="flex-item"
              v-for="(item, i) in data.agency"
              :key="i"
              @click="() => handleMenuClick(item)"
            >
              <img :src="item.file_path" />
            </a>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import mixins from "@/mixins";
import {
  bannerList,
  getAddress,
  getAgency,
  getJump,
  noticeList,
  shortcutList
} from "@/api/home";
import HeaderHome from "@/components/header-home";
import NewsItem from "@/components/news-item";
import ForumItem from "@/components/forum-item";
import ChinaMap from "@/components/china-map";

export default {
  mixins: [mixins],
  components: {
    HeaderHome,
    NewsItem,
    ForumItem,
    ChinaMap
  },
  data(){
    return {
      data: {
        carousel: [],
        shortcut: [],
        notice: [],
        address: {
          list: {},
          traincount: 0,
          servecount: 0
        },
        jump: {}
      },
      more: {},
      tabs1: 1,
      tabs2: 0
    };
  },
  methods: {
    async handleTabs1Change(type){
      const jumpMap = {
        1: "news",
        2: "notice"
      };
      this.$set(this, "more", this?.data?.jump[
        jumpMap[type]
      ]);
      this.$set(this?.data, "notice", []);
      const notice = await noticeList({
        type
      });
      this.$set(this?.data, "notice", notice);
    },
    async handleTabs2Change(show_type){
      if(!show_type){
        return;
      }
      this.$set(this?.data, "agency", []);
      const agency = await getAgency({
        show_type
      });
      this.$set(this?.data, "agency", agency);
    },
    async main(){
      const
        carousel = await bannerList(),
        notice = await noticeList({
          type: this.tabs1
        }),
        shortcut = await shortcutList(),
        address = await getAddress(),
        agency = await getAgency({
          show_type: this.tabs2
        }),
        jump = await getJump();
      this.$set(this, "more", jump.news);
      this.$set(this, "data", {
        carousel: carousel.map(
          item => ({ imgUrl: item?.file_path })
        ),
        shortcut: shortcut.map(
          item => ({ imgUrl: item?.file_path, label: item?.title })
        ),
        notice,
        address,
        agency,
        jump
      });
    }
  },
  async created(){
    await this.main();
  }
};
</script>
<style lang="less" scoped>
.carousel {
  max-height: 440px;
  .carousel-item {
    max-height: 440px;
  }
  &::v-deep {
    margin-bottom: 25px;
  }
}
.ant-tabs ::v-deep {
  .ant-tabs-tab {
    width: 140px;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
    line-height: 60px;
    padding: 0;
    &-active {
      font-weight: bold;
      color: #00349a;
    }
    &:hover {
      color: #4f9ee1;
    }
  }
  .ant-tabs-ink-bar {
    height: 6px;
    background-color: #4f9ee1;
  }
  .ant-tabs-top-bar .ant-btn-link {
    font-size: 16px;
    color: #999999;
  }
  .flex {
    flex-wrap: wrap;
  }
}
.gap {
  margin: 30px auto;
}
.area-region {
  .headline {
    max-width: 690px;
    margin: 0 auto;
    display: flex;
    text-align: center;
    margin-top: 20px;
    font-size: 30px;
    color: #4f9ee1;
    span {
      font-weight: bold;
    }
    .left, .right {
      flex: 1;
    }
  }
}
.flex-vertical,
.flex-horizontal {
  display: flex;
  flex-wrap: wrap;
  .flex-item {
    flex: 1;
    min-width: 25%;
    max-width: 25%;
    margin-bottom: 20px;
    position: relative;
    text-align: center;
  }
  &.flex-vertical {
    .description-box {
      display: none;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 260px;
      margin: auto;
      padding: 20px 0 10px;
      text-align: center;
      background-color: @primary-color;
      .label, .value {
        color: #FFFFFF;
      }
    }
    a.flex-item:hover .description-box {
      display: block;
    }
    img {
      width: 200px;
      height: 282px;
    }
  }
  &.flex-horizontal img {
    width: 260px;
    height: 184px;
  }
}
</style>